/*
 * PDP main image — prev/next arrow navigation
 *
 * Why this file exists:
 * The gallery viewer is a <slider-component> that scrolls horizontally
 * on mobile. On desktop with the "thumbnail_slider" gallery layout,
 * inactive media items are display:none (see section-main-product.css)
 * — there is nothing to scroll. Dawn's SliderComponent.update() then
 * sees only the active item as "visible" and disables BOTH prev/next
 * buttons, which is why our overlay arrows don't react to clicks.
 *
 * This script binds custom click handlers in the capture phase, calls
 * MediaGallery.setActiveMedia() to swap which item has .is-active
 * (and updates the matching thumbnail), and uses a MutationObserver
 * to keep the disabled attribute off so the click registers.
 */
(function () {
  function setupGalleryArrows(gallery) {
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    if (!viewer) return;

    const sliderButtons = viewer.querySelector('.slider-buttons');
    if (!sliderButtons) return;

    const prevBtn = sliderButtons.querySelector('button[name="previous"]');
    const nextBtn = sliderButtons.querySelector('button[name="next"]');
    if (!prevBtn || !nextBtn) return;

    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');

    function getMediaItems() {
      return Array.from(viewer.querySelectorAll('.product__media-item'));
    }

    if (getMediaItems().length < 2) {
      sliderButtons.style.display = 'none';
      return;
    }

    function getActiveIndex(items) {
      const idx = items.findIndex((item) => item.classList.contains('is-active'));
      return idx === -1 ? 0 : idx;
    }

    function navigate(direction) {
      const items = getMediaItems();
      if (items.length < 2) return;
      const newIndex = (getActiveIndex(items) + direction + items.length) % items.length;
      const newMedia = items[newIndex];
      const mediaId = newMedia && newMedia.dataset.mediaId;
      if (!mediaId) return;

      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        items.forEach((item) => item.classList.remove('is-active'));
        newMedia.classList.add('is-active');
      }

      if (thumbnails) {
        thumbnails.querySelectorAll('button[aria-current]').forEach((btn) => {
          btn.removeAttribute('aria-current');
        });
        const newThumb = thumbnails.querySelector(`[data-target="${mediaId}"] button`);
        if (newThumb) newThumb.setAttribute('aria-current', 'true');
      }
    }

    function keepEnabled() {
      prevBtn.removeAttribute('disabled');
      nextBtn.removeAttribute('disabled');
    }

    prevBtn.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        navigate(-1);
        requestAnimationFrame(keepEnabled);
      },
      true
    );

    nextBtn.addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopImmediatePropagation();
        navigate(1);
        requestAnimationFrame(keepEnabled);
      },
      true
    );

    keepEnabled();
    const disabledObserver = new MutationObserver(() => {
      if (prevBtn.hasAttribute('disabled') || nextBtn.hasAttribute('disabled')) {
        keepEnabled();
      }
    });
    disabledObserver.observe(prevBtn, { attributes: true, attributeFilter: ['disabled'] });
    disabledObserver.observe(nextBtn, { attributes: true, attributeFilter: ['disabled'] });
  }

  function init() {
    document.querySelectorAll('media-gallery').forEach(setupGalleryArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
